import { get, post } from '../utils/FetchV2.util';
import type { CanonicalRegime } from '../fiscal/canonicalRegime';
import type { PlanFamily } from '../plans/catalog';

/** De dónde salió la recomendación, en orden de confianza. */
export type PlanRecommendationSourceKey = 'sat' | 'curp' | 'declared' | 'occupation' | 'ally' | 'debt';

/**
 * EL plan mensual recomendado, como lo resuelve heru-user-management-engine
 * (módulo planrecommendation): la única regla de la web y de las campañas.
 */
export type PlanRecommendationResponse = {
	plan_family: PlanFamily | null;
	source: PlanRecommendationSourceKey | null;
	/** Regímenes con declaración mensual: los que un plan tiene que cubrir. */
	regimes: CanonicalRegime[];
	/** Todo lo que le conocemos, nómina incluida. */
	known_regimes: CanonicalRegime[];
	/** Por plan, si cubre sus regímenes. */
	coverage: Record<PlanFamily, boolean>;
};

export const getMyPlanRecommendation = () =>
	get<PlanRecommendationResponse>({
		service: 'userManagementEngine',
		endpoint: '/plan-recommendation/web/me',
	});

/** El plan que sale de una lista de regímenes (el test de plan). No lee ni guarda nada del usuario. */
export const evaluatePlanRegimes = (regimes: readonly string[]) =>
	post<PlanRecommendationResponse>({
		service: 'userManagementEngine',
		endpoint: '/plan-recommendation/web/evaluate',
		body: { regimes },
	});
